import axios from 'axios'
import { useInfiniteScroll } from './useInfiniteScroll'
import { OrderRecipeGroup, OrderRecipesResponse } from '../components/orders/types'
import { PortionType } from '../components/recipes/types'

interface OrderRecipesParams {
  query: string
  portionType: PortionType
}

export function useOrderRecipes({ query, portionType }: OrderRecipesParams) {
  const fetchPage = (page: number, signal: AbortSignal) =>
    axios
      .get<OrderRecipesResponse>('/orders/order_recipes.json', {
        params: { query, type: portionType, page },
        signal
      })
      .then(({ data }) => ({ items: data.order_recipes, hasMoreRecordsInScope: data.has_more_records_in_scope }))

  const { items, ...rest } = useInfiniteScroll<OrderRecipeGroup>(fetchPage, [query, portionType])
  return { groups: items, ...rest }
}
